/* eslint-disable no-negated-condition */
import { Connection } from '../../connections/connection.class';
import { deletePanelPassthrough } from '../../panels/helpers';
import { Island } from '../island.class';
import { Panel } from '../../panels/panel.class';
import { ReferenceMap } from '../../shared.types';

export type DeleteIslandPassthroughParams = {
    connection: Connection;
    refMap: ReferenceMap;
    island?: Island;
};

export const deleteIslandPassthrough = (params: DeleteIslandPassthroughParams): number => {
	const { connection, refMap, island = null } = params;
	let count = 0;

	if (!connection) {
		if (!island) return 0;
		island.panels.children.forEach((panel) => {
			count += deletePanelPassthrough({ panel, refMap });
		})
	} else {
		count += deletePanelPassthrough({ panel: connection.sourcePanel as Panel, refMap });
		count += deletePanelPassthrough({ panel: connection.targetPanel as Panel, refMap });
	}

	if (count !== 0) {
		console.info('%cPassthroughs were removed from the island\'s panels.', 'color:red;font-weight:bold;border:1px solid black;padding:5px;');
	}

	return count;
};
